/**
 * Created by Ivan on 11.12.2025
 */

const LightningRushGardenStartWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;

        this._super({
            name: "LightningRushGardenStartWindow",
            content: this.createContent(mission),
            notCloseByTouchInShadow: true,
            closeButton: true,
            noBackground: true,
            contentPadding: cleverapps.styles.LightningRushGardenStartWindow.contentPadding
        });
    },

    createContent: function () {
        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(cleverapps.styles.LightningRushGardenStartWindow.size);

        this.createBg();
        this.createFg();
        this.createImage();
        this.createTitle();
        this.createTimer();
        this.createText();
        this.createButton();

        return content;
    },

    createBg: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow;

        const bg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.bg_png);
        bg.setContentSize2(styles.size);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        const leftEar = new cc.Sprite(bundles.lightning_rush_frame.frames.decor_ear_png);
        bg.addChild(leftEar, -1);
        leftEar.setScaleX(-1);
        leftEar.setAlignment(styles.bg.leftEar);

        const rightEar = new cc.Sprite(bundles.lightning_rush_frame.frames.decor_ear_png);
        bg.addChild(rightEar, -1);
        rightEar.setAlignment(styles.bg.rightEar);
    },

    createFg: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow;

        const fg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.fg_png);
        this.content.addChild(fg);
        fg.setAlignment(styles.fg);
    },

    createImage: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow;

        const image = new cc.Sprite(bundles.lightning_rush_start_window.frames.picture_png);
        this.content.addChild(image);
        image.setAlignment(styles.image);
    },

    createTitle: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow;

        const titleBg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.half_title_png);
        titleBg.setContentSize2(styles.title.bg.width, titleBg.height);
        this.content.addChild(titleBg);
        titleBg.setAlignment(styles.title.bg);

        const title = cleverapps.UI.generateOnlyText(Messages.get("Missions.LightningRush.Title"), cleverapps.styles.FONTS.LIGHTING_RUSH_GARDEN_TEXT);
        this.content.addChild(title);
        title.setAlignment(styles.title);
        title.fitTo(styles.title.width);
    },

    createTimer: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow.timer;

        const bg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.substrate_png);
        bg.setContentSize2(styles.bg.width, bg.height);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        const timer = new cleverapps.CountDownView(new cleverapps.CountDown(this.mission.getTimeLeft(), {
            onFinish: this.close.bind(this)
        }), {
            font: cleverapps.styles.FONTS.LR_TIMER_TEXT
        });
        bg.addChild(timer);
        timer.setAlignment(styles);
        timer.fitTo(styles.width, styles.height);

        const icon = this.icon = new cc.Sprite(bundles.timer.frames.timer_png);
        icon.setScale(0.9);
        bg.addChild(icon);
        icon.setAlignment(styles.icon);
    },

    createText: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow.text;

        const textWrap = new cc.Node();
        textWrap.setContentSize2(styles.wrap);

        const string = cleverapps.abExperiments.getGroup(ABExperiments.Tests.energyBoosterMissions) === "A"
            ? "LightningRushGardenStartWindow.text.energyBooster"
            : "LightningRushGardenStartWindow.text";
        const text = cleverapps.UI.generateOnlyText(Messages.get(string), cleverapps.styles.FONTS.LIGHTING_RUSH_GARDEN_MAIN_TEXT);
        text.setAnchorPoint(0.5, 0.5);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        textWrap.addChild(text);
        text.setDimensions(textWrap.width, undefined);
        text.fitTo(undefined, textWrap.height);
        text.setAlignment(textWrap.width / 2, textWrap.height / 2);

        this.content.addChild(textWrap);
        textWrap.setAlignment(styles);
    },

    createButton: function () {
        const styles = cleverapps.styles.LightningRushGardenStartWindow.button;

        const button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.button_green,
            onClicked: () => {
                cleverapps.missionManager.trigger("lightningRushStart", this.mission);
                this.close();
            }
        });

        const text = cleverapps.UI.generateOnlyText(Messages.get("LightningRushGardenStartWindow.Button"), cleverapps.styles.FONTS.LIGHTING_RUSH_START_BUTTON_TEXT);
        const energy = new RewardsListComponent(this.mission.logic.getWelcomeRewards(), {
            font: cleverapps.styles.FONTS.LIGHTING_RUSH_START_REWARD_TEXT,
            iconWrap: styles.reward,
            textPosition: styles.reward.text
        });

        const layout = new cleverapps.Layout([text, energy], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.layout.margin
        });
        button.addChild(layout);
        layout.setAlignment(styles.layout);
        cleverapps.UI.fitToBox(layout, { width: button.width * 0.7, height: button.height * 0.9 });
        this.content.addChild(button);
        button.setAlignment(styles);
    },

    listBundles: function () {
        return ["lightning_rush_start_window"];
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    LIGHTING_RUSH_GARDEN_COLOR: new cc.Color(35, 35, 165, 255)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    LIGHTNING_RUSH_STROKE: {
        size: 2,
        color: cleverapps.styles.COLORS.LIGHTING_RUSH_GARDEN_COLOR
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LIGHTING_RUSH_GARDEN_TEXT: {
        size: 55,
        stroke: cleverapps.styles.DECORATORS.LIGHTNING_RUSH_STROKE,
        color: cleverapps.styles.COLORS.WHITE
    },
    LR_TIMER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    LIGHTING_RUSH_GARDEN_MAIN_TEXT: {
        size: 33,
        name: "nostroke",
        color: cleverapps.styles.COLORS.WHITE
    },

    LIGHTING_RUSH_START_BUTTON_TEXT: {
        size: 65,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    LIGHTING_RUSH_START_REWARD_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.styles.LightningRushGardenStartWindow = {
    size: {
        width: 660,
        height: 1030
    },

    bg: {
        x: { align: "center" },
        y: { align: "center" },

        leftEar: {
            x: { align: "left", dx: 0 },
            y: { align: "top", dy: 180 }
        },
        rightEar: {
            x: { align: "right", dx: 0 },
            y: { align: "top", dy: 180 }
        }
    },

    fg: {
        x: { align: "center" },
        y: { align: "bottom", dy: 10 }
    },

    image: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 180 }
    },

    title: {
        bg: {
            width: 750,
            x: { align: "center" },
            y: { align: "top", dy: 98 }
        },

        x: { align: "center" },
        y: { align: "top", dy: 71 },
        width: 400
    },

    timer: {
        width: 150,
        height: 60,
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: 10 },
        icon: {
            x: { align: "center", dx: -90 },
            y: { align: "center", dy: 10 }
        },
        bg: {
            width: 705,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -172 }
        }
    },

    button: {
        width: 280,
        height: 93,
        x: { align: "center" },
        y: { align: "bottom", dy: 35 },

        layout: {
            margin: 0,
            x: { align: "center", dx: -10 },
            y: { align: "center", dy: 3 }
        },

        reward: {
            width: 100,
            height: 100,
            text: {
                x: { align: "right", dx: 40 },
                y: { align: "bottom", dy: 0 }
            }
        }
    },

    text: {
        wrap: {
            width: 620,
            height: 180
        },
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 135 }
    },

    contentPadding: {
        top: 150
    }
};

if (cleverapps.config.type === "merge2") {
    LightningRushStartWindow = LightningRushGardenStartWindow;
}